import { Link as GatsbyLink, PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AnalyticsPageType } from '@shopify/hydrogen-react';

import SeoHead from '../components/head';
import { HorizontalSlantContainer } from '../components/horizontal-slant-container';
import { useAnalytics } from '../shared/analytics';

export default function NotFound() {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.trackPageView(AnalyticsPageType.notFound);
  }, [])

  return (
    <>
      <HorizontalSlantContainer id={"404notfound"} autoHeight>
        <Box sx={{ height: { xs: "110px", sm: "125px", md: "125px" } }}></Box>
      </HorizontalSlantContainer>

      <Container sx={{ mt: 7, mb: 7 }}>
        <Stack gap={5}>
          <Typography
            variant="h1"
            sx={{ fontWeight: 700, fontSize: "1.5rem", textAlign: "center" }}
          >
            This is awkward...
          </Typography>
          <Typography variant="h3">
            We couldn't find what you were looking for.
          </Typography>
          <Button
            to="/"
            variant="outlined"
            component={GatsbyLink}
            startIcon={<ChevronLeft />}
          >
            Return home
          </Button>
        </Stack>
      </Container>
    </>
  )
}
export const Head = (props: PageProps) => {
  return (
    <SeoHead title="Not found" pathname={props.location.pathname} description="Requested resource cannot be found" />
  )
}
